(function () {
  var saLoaded = false;
  var pendingSearchOpen = false;
  var pendingFocusElement = null;
  var isTriggeringOpen = false;

  var searchaniseScript =
    "https://searchanise-ef84.kxcdn.com/widgets/shopify/init.js?a=3e3M1v8T0a&shop=dovetailworkwear.myshopify.com";

  function isSearchResultsPage() {
    if (
      location.pathname === "/pages/search-results-page" ||
      location.pathname === "/search"
    ) {
      console.log("[Searchanise] Search results page detected — loading immediately");
      return true;
    }
    return false;
  }

  function triggerSearchaniseOpen() {
    if (isTriggeringOpen) return;
    isTriggeringOpen = true;

    var saInputSelectors = [
      'input[name="q"]',
      '.mm-search > input[type="text"]'
    ];

    var target = pendingFocusElement;
    if (!target) {
      for (var i = 0; i < saInputSelectors.length; i++) {
        var el = document.querySelector(saInputSelectors[i]);
        if (el) { target = el; break; }
      }
    }

    pendingFocusElement = null;

    if (!target) {
      console.warn("[Searchanise] No search input found to trigger open");
      isTriggeringOpen = false;
      return;
    }

    console.log("[Searchanise] Triggering SA via input focus:", target);

    // Remove OUR listeners before firing synthetic events to prevent loops
    target.removeEventListener("focus", onInputFocus);
    target.removeEventListener("click", onInputClick);

    // Open Shopify's native search modal if it exists and is closed
    var searchModal = document.querySelector(
      "details-modal.header__search, details.header__search"
    );
    if (searchModal && !searchModal.hasAttribute("open")) {
      searchModal.setAttribute("open", "");
    }

    target.removeAttribute("aria-hidden");
    target.focus();
    target.dispatchEvent(new Event("input", { bubbles: true }));
    target.dispatchEvent(new MouseEvent("click", { bubbles: true }));

    isTriggeringOpen = false;
  }

  function loadSearchanise(priority, openOnLoad) {
    if (openOnLoad) {
      pendingSearchOpen = true;
    }

    if (saLoaded) {
      //console.log("[Searchanise] Already loaded, skipping");
      if (pendingSearchOpen) {
        pendingSearchOpen = false;
        triggerSearchaniseOpen();
      }
      return;
    }
    saLoaded = true;

    // Tell Yett to allow Searchanise now
    if (window.yett) {
      if (typeof window.yett.unblock === "function") {
        window.yett.unblock(/searchanise/);
      }
      if (typeof window.yett.allow === "function") {
        window.yett.allow(/searchanise/);
      }
    }

    // Listen for Searchanise readiness
    document.addEventListener("Searchanise.Loaded", function onSearchaniseLoaded() {
      if (window.Searchanise) {
        document.documentElement.classList.add("searchanise-ready");
        console.log("[Searchanise] Ready");

        if (pendingSearchOpen) {
          pendingSearchOpen = false;
          console.log("[Searchanise] Fulfilling pending search open...");
          setTimeout(triggerSearchaniseOpen, 150);
        }
      }
    });

    // Check if script already exists
    var exists = Array.from(document.querySelectorAll("script")).some(function (s) {
      return s.src && s.src.indexOf("searchanise-ef84.kxcdn.com") !== -1;
    });

    if (exists) {
      return;
    }

    // Create and append the script
    var s = document.createElement("script");
    s.src = searchaniseScript;
    s.type = "text/javascript";

    if (priority !== "high") {
      s.defer = true;
    }

    s.onerror = function () {
      console.error("[Searchanise] Script failed to load");
      saLoaded = false;
    };

    s.onload = function () {
      console.log("[Searchanise] Script loaded successfully");
    };

    document.head.appendChild(s);
  }

  // === Load strategy ===

  // 1. Immediate load on search results page
  if (isSearchResultsPage()) {
    loadSearchanise("high");
    return;
  }

  // 2. Intent-based triggers (generic — no open intent)
  var userIntentEvents = [
    "mousedown",
    "mousemove",
    "keydown",
    "scroll",
    "touchstart",
  ];

  function onUserIntent() {
    console.log("[Searchanise] User intent detected, loading...");
    loadSearchanise();
    removeIntentListeners();
  }

  function removeIntentListeners() {
    userIntentEvents.forEach(function (event) {
      document.removeEventListener(event, onUserIntent, {
        passive: true,
        capture: true,
      });
    });
  }

  userIntentEvents.forEach(function (event) {
    document.addEventListener(event, onUserIntent, {
      once: true,
      passive: true,
      capture: true,
    });
  });

  // 3. Idle/post-load fallback
  if ("requestIdleCallback" in window) {
    requestIdleCallback(function () {
      setTimeout(loadSearchanise, 2000);
    });
  } else {
    setTimeout(loadSearchanise, 3000);
  }

  // 4. Named input listeners so they can be removed before synthetic events fire
  function onInputFocus(e) {
    if (isTriggeringOpen) return;
    pendingFocusElement = e.currentTarget;
    loadSearchanise("high", true);
  }

  function onInputClick(e) {
    if (isTriggeringOpen) return;
    pendingFocusElement = e.currentTarget;
    loadSearchanise("high", true);
  }

  function initSearchInteraction() {
    var searchIcons = document.querySelectorAll(
      ".header__icon--search, .search-modal__toggle, details-modal.header__search summary"
    );
    var searchInputs = document.querySelectorAll(
      'input[name="q"], .mm-search > input[type="text"]'
    );

    searchIcons.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        if (isTriggeringOpen) return;
        pendingFocusElement = document.querySelector('input[name="q"]') || null;
        removeIntentListeners();
        loadSearchanise("high", true);
      });
    });

    searchInputs.forEach(function (input) {
      input.addEventListener("focus", onInputFocus);
      input.addEventListener("click", onInputClick);
    });
  }

  // Wait for DOM or initialize immediately
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSearchInteraction);
  } else {
    initSearchInteraction();
  }

  // Expose loader for manual control
  window.SearchaniseLoader = {
    load: loadSearchanise,
    isLoaded: function () { return saLoaded; }
  };

  console.log("[Searchanise] Defer loader initialized");
})();